var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basic Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1759 10.4995L14.7593 6.9245C14.9162 6.76758 15.0043 6.55475 15.0043 6.33284C15.0043 6.11092 14.9162 5.89809 14.7593 5.74117C14.6023 5.58425 14.3895 5.49609 14.1676 5.49609C13.9457 5.49609 13.7328 5.58425 13.5759 5.74117L10.0009 9.3245L6.42593 5.74117C6.26901 5.58425 6.05618 5.49609 5.83426 5.49609C5.61234 5.49609 5.39951 5.58425 5.24259 5.74117C5.08567 5.89809 4.99752 6.11092 4.99752 6.33284C4.99752 6.55475 5.08567 6.76758 5.24259 6.9245L8.82593 10.4995L5.24259 14.0745C5.16449 14.152 5.10249 14.2441 5.06018 14.3457C5.01788 14.4472 4.99609 14.5562 4.99609 14.6662C4.99609 14.7762 5.01788 14.8851 5.06018 14.9867C5.10249 15.0882 5.16449 15.1804 5.24259 15.2578C5.32006 15.3359 5.41223 15.3979 5.51378 15.4402C5.61533 15.4826 5.72425 15.5043 5.83426 15.5043C5.94427 15.5043 6.05319 15.4826 6.15474 15.4402C6.25629 15.3979 6.34846 15.3359 6.42593 15.2578L10.0009 11.6745L13.5759 15.2578C13.6534 15.3359 13.7456 15.3979 13.8471 15.4402C13.9487 15.4826 14.0576 15.5043 14.1676 15.5043C14.2776 15.5043 14.3865 15.4826 14.4881 15.4402C14.5896 15.3979 14.6818 15.3359 14.7593 15.2578C14.8374 15.1804 14.8994 15.0882 14.9417 14.9867C14.984 14.8851 15.0058 14.7762 15.0058 14.6662C15.0058 14.5562 14.984 14.4472 14.9417 14.3457C14.8994 14.2441 14.8374 14.152 14.7593 14.0745L11.1759 10.4995Z",
    fill: "#EF4444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseicon);
export default __webpack_public_path__ + "static/media/closeicon.3d610cdf34d03b211d1a62e6d504b50a.svg";
export { ForwardRef as ReactComponent };